module.exports = __webpack_public_path__ + "media/images/about_us/construction-29d9a898d2c5dc96f104fee4933a6c9c.svg";